import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15859e93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "boardView has-text-left" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "titleWrap p-4" }
const _hoisted_4 = { class: "t is-size-4 has-text-link has-text-weight-medium" }
const _hoisted_5 = { class: "my_board_option_wrap mt-3" }
const _hoisted_6 = {
  key: 0,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_editor_v3 = _resolveComponent("md-editor-v3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.is_my_board)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "button mr-2",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reWriteBoard && _ctx.reWriteBoard(...args)))
              }, "수정"),
              _createElementVNode("button", {
                class: "button mr-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteBoard && _ctx.deleteBoard(...args)))
              }, "삭제")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{'isDesk' : _ctx.isEditorDesktop}, "cont has-text-left p-4"])
      }, [
        _createVNode(_component_md_editor_v3, {
          class: "MyEditor",
          "preview-only": "",
          modelValue: _ctx.cont,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cont) = $event)),
          language: "en-US"
        }, null, 8, ["modelValue"])
      ], 2)
    ])
  ]))
}